import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useHeaderFlyoutStore } from '../../../../../shared';
export type AccountPopoverVariant = 'desktop' | 'tablet' | 'mobile';
type UseAccountPopoverOptions = {
  variant: AccountPopoverVariant;
};
type OnOpenChange = NonNullable<Popover.Root.Props['onOpenChange']>;
export function useAccountPopover(t0) {
  const $ = _c(21);
  const {
    variant
  } = t0;
  const isDesktop = variant === "desktop";
  const actionsRef = useRef(null);
  const toggleRef = useRef(null);
  const setFlyoutOpen = useHeaderFlyoutStore(_temp);
  const [openedWithKeyboard, setOpenedWithKeyboard] = useState(false);
  const [mobileAnchor, setMobileAnchor] = useState(null);
  const [portalContainer, setPortalContainer] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = element => {
      setMobileAnchor(element?.closest(".header__main-section-container") ?? null);
      setPortalContainer(element?.closest(".header__main-section-sticky") ?? null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setPopoverRoot = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function close() {
      actionsRef.current?.close();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] !== isDesktop || $[3] !== setFlyoutOpen) {
    t3 = (open, eventDetails) => {
      if (isDesktop) {
        setFlyoutOpen("account", open);
      }
      if (!open || eventDetails.reason === "trigger-hover") {
        setOpenedWithKeyboard(false);
      }
      if (!open && eventDetails.reason === "escape-key") {
        requestAnimationFrame(() => toggleRef.current?.focus());
      }
    };
    $[2] = isDesktop;
    $[3] = setFlyoutOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onOpenChange = t3;
  let t4;
  let t5;
  if ($[5] !== isDesktop || $[6] !== setFlyoutOpen) {
    t4 = () => {
      if (!isDesktop) {
        return;
      }
      return () => setFlyoutOpen("account", false);
    };
    t5 = [isDesktop, setFlyoutOpen];
    $[5] = isDesktop;
    $[6] = setFlyoutOpen;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== onOpenChange) {
    t6 = {
      actionsRef,
      onOpenChange
    };
    $[9] = onOpenChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpenedWithKeyboard(true);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isDesktop || $[13] !== openedWithKeyboard) {
    t8 = {
      isDesktop,
      onClose: close,
      onKeyboardOpen: t7,
      openedWithKeyboard,
      toggleRef
    };
    $[12] = isDesktop;
    $[13] = openedWithKeyboard;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isDesktop || $[16] !== mobileAnchor || $[17] !== portalContainer || $[18] !== t6 || $[19] !== t8) {
    t9 = {
      close,
      isDesktop,
      mobileAnchor,
      portalContainer,
      rootProps: t6,
      setPopoverRoot,
      triggerProps: t8
    };
    $[15] = isDesktop;
    $[16] = mobileAnchor;
    $[17] = portalContainer;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp(state) {
  return state.setFlyoutOpen;
}